import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
    selector: 'app-annule-cmd',
    templateUrl: './annule-cmd.component.html',
    styleUrls: ['./annule-cmd.component.scss']
})
export class AnnuleCmdComponent implements OnInit {
    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('AnnuleCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Annulé');
    }
}
